<lib-cdw-button
  class="icon-button"
  (click)="onClick($event)"
  level="tertiary"
  mode="icon"
  [disabled]="false"
  icon="delete_outline"
  [useMatIcon]="useMatIcon"
  [customIconColor]="customTextColor"
></lib-cdw-button>
